import { z } from 'my-zod'
import { LanguageEnum } from '../../internal'

export const SelectWelcomeNotification = z.object({
  email: z.string(),
  fullName: z.string(),
  getStartedUrl: z.string(),
  loginUrl: z.string(),
  planName: z.string(),
  preferredLanguage: LanguageEnum,
  customerId: z.string().optional(),
  subscriptionId: z.string().optional()
})
export type SelectWelcomeNotification = z.infer<typeof SelectWelcomeNotification>
